import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { IUserExternalSystem } from "../../../models/externalSystem/userExternalSystem";
import { ListExternalSystemLine } from "../../framework/List/ListExternalSystemLine";
import { ListHeaderLine } from "../../framework/List/ListLine";

export interface ICompanyEditExternalSystemsProp {
    externalSystems: IUserExternalSystem[];
    onToggeExternalSystemInUse: (code: string, value: boolean) => void;
    onChangeExternalSystemExternalCode: (code: string, value: string) => void;
}

export class CompanyEditExternalSystems extends React.Component<ICompanyEditExternalSystemsProp, {}> {
    handleChangeExternalSystemExternalCode = (event) => {
        const target = event.target;
        const value: string = target.value;
        const code: string = target.name;
        if (!code) return;
        this.props.onChangeExternalSystemExternalCode(code, value);
    };

    render() {
        const props = this.props;
        const externalSystems = props.externalSystems;
        if (!externalSystems || externalSystems.length < 0) return null;
        return (
            <>
                <ListHeaderLine
                    columns={[
                        { size: 7, column: "name", content: Translations.Name },
                        { size: 5, column: "externalSystemCode", content: Translations.ExternalSystemCode }
                    ]}
                />
                {externalSystems.map((externalSystem) =>
                    <ListExternalSystemLine
                        key={externalSystem.code}
                        code={externalSystem.code}
                        name={externalSystem.name}
                        checked={externalSystem.inUse}
                        value={externalSystem.externalCode}
                        onCheckChange={props.onToggeExternalSystemInUse}
                        onInputChange={this.handleChangeExternalSystemExternalCode}
                    />
                )}
            </>
        );
    }
}